import { Component } from '@angular/core';

@Component({
    selector: 'app-lazada-e-commerce-callback',
    templateUrl: './lazada-e-commerce-callback.component.html',
    styleUrl: './lazada-e-commerce-callback.component.scss',
    standalone: false
})
export class LazadaECommerceCallbackComponent {

}
